import { render, staticRenderFns } from "./Chem51LBProject1OITheory.vue?vue&type=template&id=1e53730b&scoped=true&"
import script from "./Chem51LBProject1OITheory.vue?vue&type=script&lang=ts&"
export * from "./Chem51LBProject1OITheory.vue?vue&type=script&lang=ts&"
import style0 from "./Chem51LBProject1OITheory.vue?vue&type=style&index=0&id=1e53730b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53730b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
